import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from 'material-ui/LinearProgress';
import './bootstrapCardWithFilter.scss';
import LinesPeriodPicker from '../../../../src/components/dashboard/comp/linesData/linesPeriodPicker/LinesPeriodPickerConnector';

const BootstrapCardWithFilter = ({ children, width, minWidth, fullWidth, contentStyle, loading, disabled, titleButtons, margin, padding }) => (
  <div className={ `bootstrap-card-filter__main-container${!fullWidth?' bootstrap-card-filter__main-container_inline':''}` } style={ { width, minWidth, margin } } >
    <div className={ `bootstrap-card-filter__title-container${loading?' blur-content': ''}` }>
      <LinesPeriodPicker />
      <h2 style={ { margin: 'auto 10px' } }>Lines Status</h2>
      <div className={ 'bootstrap-card-filter__button-container' }>
        { titleButtons.map(({ label, onClick }) => <span key={ label.replace(/ /g,"_") } onClick={ onClick }>{ label }</span>) }
      </div>
    </div>
    <div className={ `bootstrap-card-filter__content${loading?' blur-content': ''}` } style={ { contentStyle, padding} }>
      { children }
    </div>
    {
      loading && <div className="bootstrap-card-filter__overlay">
        <LinearProgress mode="indeterminate"/>
      </div>
    }
    {
      !loading && disabled && <div className="bootstrap-card-filter__disabled" />
    }
  </div>
);

BootstrapCardWithFilter.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  minWidth: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  margin: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  fullWidth: PropTypes.bool,
  contentStyle: PropTypes.object,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  titleButtons: PropTypes.array,
  padding: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ])
};

BootstrapCardWithFilter.defaultProps = {
  width: 'auto',
  minWidth: 'auto',
  fullWidth: true,
  contentStyle: {},
  loading: false,
  disabled: false,
  titleButtons: []
};

export default BootstrapCardWithFilter;



// WEBPACK FOOTER //
// ./src/shared/components/bootstrapCardWithFilter/bootstrapCardWithFilter.js